const it = {
  common: {
    loading: "Caricamento",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    create: "Crea",
    back: "Indietro",
    download: "Scarica",
    upload: "Carica",
    search: "Cerca",
    add: "Aggiungi",
    remove: "Rimuovi",
    yes: "Sì",
    no: "No",
    optional: "Opzionale",
    confirm: "Conferma",
    error: "Errore imprevisto. Riprova.",
    no_results: "Nessun risultato.",
    actions: "Azioni",
    premium_only: "Funzione disponibile solo nel piano Premium",
    upgrade_to_unlock: "Passa a Premium per sbloccare",
  },
  nav: {
    dashboard: "Dashboard",
    events: "Eventi",
    clients: "Clienti",
    calendar: "Calendario",
    suppliers: "Rubrica",
    guide: "Guida",
    settings: "Impostazioni",
    logout: "Esci",
    dark: "Scuro",
    light: "Chiaro",
  },
  auth: {
    forgot_password: "Hai dimenticato la password?",
    forgot_title: "Recupera l'accesso",
    forgot_subtitle: "Inserisci l'email del tuo account: ti mandiamo un link per scegliere una password nuova.",
    forgot_submit: "Mandami il link",
    forgot_sending: "Invio…",
    forgot_sent_title: "Controlla la posta",
    forgot_sent_body: "Se l'indirizzo corrisponde a un account, tra poco ricevi un'email con il link. Vale un'ora e si usa una volta sola.",
    forgot_back: "Torna all'accesso",
    reset_title: "Scegli una password nuova",
    reset_subtitle: "Almeno 8 caratteri.",
    reset_password: "Nuova password",
    reset_confirm: "Ripeti la password",
    reset_mismatch: "Le due password non coincidono.",
    reset_too_short: "La password deve avere almeno 8 caratteri.",
    reset_submit: "Salva la password",
    reset_saving: "Salvataggio…",
    reset_done: "Password aggiornata. Ora puoi accedere.",
    reset_invalid_title: "Link non piu' valido",
    reset_invalid_body: "Questo link e' scaduto o e' gia' stato usato. Richiedine uno nuovo.",
    reset_request_new: "Richiedi un nuovo link",
    reset_checking: "Verifico il link…",
    welcome_back: "Bentornato",
    fill_credentials: "Inserisci email e password.",
    invalid_email: "Indirizzo email non valido.",
    login_title: "Accedi al tuo studio",
    login_subtitle: "Il gestionale dedicato ai wedding planner professionisti.",
    email: "Email",
    password: "Password",
    login: "Accedi",
    logging_in: "Accesso…",
    no_account: "Non hai un account?",
    create_account: "Crea il tuo studio",
    have_account: "Hai già un account?",
    register_title: "Crea il tuo studio",
    name: "Nome",
    creating: "Creazione…",
    create_button: "Crea account",
    welcome_demo: "Demo",
  },
  dashboard: {
    title: "Buongiorno",
    studio: "Studio",
    all_events: "Tutti gli eventi",
    active_events: "Eventi attivi",
    budget_engaged: "Budget impegnato",
    paid_suppliers: "Pagato fornitori",
    contracts_signed: "Preventivi confermati",
    tasks_due: "Task in scadenza",
    of_total: "su {{total}} totali",
    of_budget: "{{pct}}% del budget",
    cumulated: "cumulato",
    signed_ratio: "rapporto firmati",
    next_7_days: "prossimi 7 giorni",
    next_payment: "Prossima scadenza pagamento",
    deadline: "Scadenza",
    upcoming_events: "Prossimi eventi",
    all: "Tutti",
    recent_payments: "Ultimi pagamenti",
    no_events: "Nessun evento in programma.",
    no_payments: "Nessun pagamento registrato.",
    categories_chart: "Preventivi per categoria",
    no_quotes: "Nessun preventivo registrato.",
  },
  events: {
    title: "Eventi & Matrimoni",
    count_one: "{{n}} evento",
    count_other: "{{n}} eventi",
    concluded: "Concluso",
    upcoming_section: "In arrivo",
    concluded_section: "Archiviati",
    new_event: "Nuovo Evento",
    new_event_title: "Nuovo evento",
    invalid_budget: "Il budget non può essere negativo. Inserisci un valore ≥ 0.",
    budget_required: "Inserisci il budget dell'evento.",
    invalid_name: "Inserisci il nome dell'evento.",
    invalid_date: "La data dell'evento è obbligatoria.",
    past_date_warning: "La data dell'evento è nel passato.",
    link_client_label: "Cliente collegato (opzionale)",
    link_client_placeholder: "Seleziona cliente dalla CRM…",
    link_client_none: "Nessun cliente collegato",
    link_client_all_taken: "Tutti i clienti della CRM hanno già un evento collegato.",
    event_name: "Nome evento",
    date: "Data",
    location: "Location",
    budget_total: "Budget totale (€)",
    notes: "Note",
    no_events: "Nessun evento",
    no_events_subtitle: "Inizia creando il tuo primo matrimonio.",
    delete_event: "Elimina evento",
    delete_confirm: "Questa operazione eliminerà definitivamente l'evento e tutti i dati collegati: fornitori, pagamenti, attività e ospiti. Non può essere annullata.",
    deleted: "Evento eliminato",
    location_placeholder: "Location da definire",
    invitees: "Gruppi confermati",
    tasks: "Task",
    suppliers: "Fornitori",
    budget: "Budget",
    residual: "Residuo",
    paid_short: "Pagato",
    tab: {
      panoramica: "Panoramica",
      budget: "Budget",
      fornitori: "Fornitori",
      pagamenti: "Pagamenti",
      invitati: "Invitati",
      tavoli: "Tavoli",
      attivita: "Attività",
      timeline: "Timeline",
      file: "File",
      contratti: "Contratti",
      moodboard: "Moodboard",
      portale: "Portale",
    },
    overview: {
      budget: "Budget",
      total: "Totale",
      quoted: "Preventivato",
      committed: "Confermato",
      paid: "Pagato",
      remaining: "Residuo",
      over_budget: "Sforamento budget",
      invitees: "Invitati",
      confirmed: "Confermati (gruppi)",
      pending: "In Attesa (gruppi)",
      refused: "Rifiutati (gruppi)",
      total_people: "Persone totali",
      summary: "Sintesi",
      tasks_done: "Task done",
      next_deadlines: "Prossime scadenze",
      no_deadlines: "Nessuna scadenza imminente.",
      no_quotes: "Nessun preventivo.",
      quotes_by_cat: "Preventivi per categoria",
    },
    budget_tab: {
      total: "Budget totale",
      saved: "Budget aggiornato",
      invalid_negative: "Il budget non può essere negativo. Inserisci un valore ≥ 0.",
      paid_total: "Pagato / Totale",
      export_csv: "Esporta CSV",
      export_pdf: "Esporta PDF",
      remaining_budget: "Residuo preventivato",
      remaining_budget_hint: "Quanto budget hai ancora libero da assegnare ai fornitori (Totale − Preventivato).",
      remaining_budget_over: "Sforamento: i preventivi superano il budget totale.",
      remaining_pay: "Residuo da pagare",
      remaining_pay_hint: "Quanto resta da saldare dei contratti firmati (Confermato − Pagato).",
      remaining_pay_overpaid: "Pagato supera il confermato",
      committed_legend: "Confermato = somma dei preventivi con contratto FIRMATO. Cambia lo stato a 'Firmato' nel tab Fornitori per popolare automaticamente questo valore.",
    },
    suppliers_tab: {
      linked: "Fornitori collegati ({{n}})",
      link_supplier: "Collega Fornitore",
      link_title: "Collega fornitore",
      from_address_book: "Fornitore (dalla Rubrica)",
      select: "Seleziona…",
      all_linked: "Tutti i fornitori sono già collegati",
      all_linked_hint: "Nessun fornitore aggiuntivo disponibile nella tua Rubrica.",
      quote: "Preventivo (€)",
      contract: "Contratto",
      no_suppliers: "Nessun fornitore collegato. Aggiungi dalla rubrica.",
      select_supplier_first: "Seleziona un fornitore",
      linked_ok: "Fornitore collegato",
      unlinked_ok: "Fornitore scollegato dall'evento",
      delete_link_title: "Scollegare fornitore?",
      delete_link_confirm: "Scollegare questo fornitore dall'evento? Le rate e i contratti collegati non verranno eliminati.",
      link_button: "Collega",
      preview_label: "Preventivo",
    },
    payments_tab: {
      quoted: "Preventivato",
      committed: "Confermato",
      paid: "Pagato",
      residual: "Residuo",
      invalid_supplier: "Inserisci il nome del fornitore.",
      invalid_amount: "L'importo deve essere maggiore di 0.",
      add_installment: "Aggiungi rata",
      add_title: "Nuova rata",
      supplier_name: "Nome fornitore",
      type: "Tipo",
      amount: "Importo €",
      due_date: "Scadenza",
      status: "Stato",
      iban: "IBAN (opz.)",
      all_statuses: "Tutti gli stati",
      no_installments: "Nessuna rata.",
      installment_added: "Rata aggiunta",
      export_csv: "Esporta CSV",
      export_pdf: "Esporta PDF",
      amount_label: "Importo",
    },
    guests_tab: {
      people: "Persone",
      confirmed: "Confermati (persone)",
      groups: "gruppi",
      pending: "In Attesa (gruppi)",
      refused: "Rifiutati (gruppi)",
      all_sources: "Tutte le fonti",
      manual: "Manuali",
      website: "Website",
      csv: "CSV",
      new_guest: "Nuovo invitato",
      add_title: "Aggiungi invitato",
      name: "Nome",
      email: "Email",
      pax: "Pax",
      no_guests: "Nessun invitato.",
      guest_added: "Invitato aggiunto",
      guest_updated: "Invitato aggiornato",
      email_collision_title: "Email già usata da un altro invitato",
      email_collision_desc: "Esiste già un invitato collegato a questa email. Cosa preferisci fare?",
      email_collision_merge: "Aggiorna esistente",
      email_collision_create: "Aggiungi comunque",
      import_csv: "Importa CSV",
      import_csv_title: "Importa invitati da CSV",
      import_csv_help: "Carica un file CSV con colonne: name, email, pax, rsvp_status, diet_tags, notes.",
      import_csv_done: "Importati {{ok}} invitati ({{err}} errori)",
      public_link: "Link RSVP pubblico",
      copy_link: "Copia link",
      link_copied: "Link copiato negli appunti",
    },
    tables_tab: {
      title: "Piano Tavoli",
      add_table: "Nuovo tavolo",
      edit_table: "Modifica tavolo",
      table_name: "Nome tavolo",
      capacity: "Capacità",
      shape: "Forma",
      round: "Rotondo",
      rectangular: "Rettangolare",
      rotation: "Rotazione",
      shape_round: "Rotondo",
      shape_rectangular: "Rettangolare / Imperiale",
      shape_square: "Quadrato",
      shape_oval: "Ovale",
      shape_crescent: "Mezzaluna",
      shape_horseshoe: "Ferro di cavallo",
      shape_custom: "Forma personalizzata",
      zoom_in: "Ingrandisci",
      zoom_out: "Riduci",
      zoom_fit: "Adatta alla pagina",
      guests_at_table: "Ospiti al tavolo",
      toggle_background: "Mostra/nascondi pianta di sfondo",
      no_tables: "Nessun tavolo creato. Crea il primo per iniziare ad assegnare gli invitati.",
      no_floorplan_hint: "Carica una pianta della sala o aggiungi i tavoli a mano",
      move_hint: "Trascina per spostare il tavolo",
      seated: "Seduti",
      drag_help: "Trascina gli invitati nei tavoli. Usa la maniglia per spostare i tavoli sulla planimetria.",
      unassigned: "Senza tavolo",
      export_pdf: "Esporta mappa PDF",
      saved: "Salvato",
    },
    floorplan: {
      upload: "Carica pianta",
      replace: "Sostituisci pianta",
      remove: "Rimuovi pianta",
      uploading: "Caricamento…",
      uploaded: "Pianta caricata",
      delete_confirm: "Rimuovere la pianta della sala?",
      generate: "Genera tavoli con AI",
      analyzing: "Lettura pianta…",
      no_tables_found: "Nessun tavolo riconosciuto nella pianta. Aggiungili a mano.",
      draft_title: "Tavoli riconosciuti",
      draft_help: "Deseleziona quelli che non vuoi. Potrai spostarli e correggerli dopo.",
      tables_added: "{n} tavoli aggiunti",
      confirm: "Conferma {n} tavoli",
      convert_error: "Impossibile leggere il file. Usa un PDF o un'immagine valida.",
      choose_page: "Quale pagina contiene la pianta?",
      use_this_page: "Usa questa pagina",
      include_elements: "Riporta anche sala ed elementi fissi ({n}: pista, palco, buffet…)",
      from_cache: "Pianta già analizzata: risultato dalla cache, nessun costo AI",
      reanalyze: "Rianalizza",
      notes_placeholder: "Indicazioni per l'AI (opzionali) — es: i tavoli sono le sagome bianche: una mezzaluna in alto e due serpentine ai lati; i cerchi verdi sono alberi, non tavoli.",
    },
    tasks_tab: {
      add: "Nuova attività",
      add_title: "Nuova attività",
      title_label: "Titolo",
      due_date: "Scadenza",
      todo: "Da Fare",
      doing: "In Corso",
      done: "Completato",
      none: "Nessuna",
      created: "Attività creata",
    },
    timeline_tab: {
      add: "Nuova voce",
      add_title: "Nuova voce timeline",
      time: "Orario (HH:MM)",
      title_label: "Titolo",
      category_label: "Voce",
      category_placeholder: "Seleziona una voce…",
      custom_title_label: "Titolo personalizzato",
      location: "Luogo",
      description: "Descrizione",
      no_items: "Nessuna voce. Aggiungi la prima per costruire la scaletta.",
      saved: "Voce salvata",
      edit: "Modifica voce timeline",
      edit_title: "Modifica voce timeline",
      updated: "Voce aggiornata",
    },
    timeline_categories: {
      welcome: "Welcome / Arrivo ospiti",
      cerimonia: "Cerimonia",
      aperitivo: "Aperitivo / Cocktail",
      foto_sposi: "Foto sposi",
      pranzo: "Pranzo",
      cena: "Cena",
      taglio_torta: "Taglio della torta",
      lancio_bouquet: "Lancio del bouquet",
      primo_ballo: "Primo ballo",
      open_bar: "Open bar",
      animazione: "Animazione / DJ set",
      confettata: "Confettata",
      sweet_table: "Sweet table",
      lancio_riso: "Lancio del riso",
      saluti: "Saluti finali",
      tradizioni: "Tradizioni",
      custom: "Personalizzato",
    },
    files_tab: {
      drag_drop: "Trascina qui i file o clicca per selezionarli",
      no_files: "Nessun file caricato.",
      uploaded: "File caricato",
      size: "Dimensione",
      uploaded_at: "Caricato il",
    },
    contracts_tab: {
      placeholder_title: "Contratti",
      placeholder_desc: "Carica i PDF e invia per firma elettronica. Disponibile nella fase 3.",
      title: "Contratti dei fornitori",
      event_hint: "I contratti si caricano qui, sotto ogni fornitore collegato a questo evento, e restano legati a questo matrimonio. (Lo stato del contratto — Da Confermare/Confermato/Pagato — si imposta invece nel tab Fornitori.)",
      empty_title: "Nessun fornitore collegato",
      empty_subtitle_event: "Collega prima i fornitori a questo evento dal tab Fornitori: qui potrai poi caricare i loro contratti.",
      count: "{{n}} contratto/i",
      download: "Scarica",
      upload: "Carica contratto",
      uploading: "Carico…",
      remove: "Elimina",
      delete_confirm: "Eliminare questo contratto?",
      format_hint: "PDF, DOCX o CSV.",
      no_contracts: "Nessun contratto caricato per questo fornitore.",
    },
    moodboard_tab: {
      title: "Moodboard ispirazione",
      subtitle: "Carica immagini di riferimento (palette, location, dettagli) condivisibili con la coppia.",
      add_image: "Aggiungi immagine",
      drag_drop: "Trascina qui una o più immagini oppure fai clic qui per scegliere i file",
      uploading: "Caricamento…",
      uploaded: "Immagine caricata",
      uploaded_many: "{{n}} immagini caricate",
      rejected_files: "{{n}} file ignorati: usa immagini fino a 50 MB",
      delete_confirm: "Eliminare questa immagine dal moodboard?",
      delete_gallery: "Elimina galleria",
      delete_gallery_confirm: "Eliminare tutte le immagini della galleria? Questa operazione non può essere annullata.",
      gallery_deleted: "Galleria eliminata",
      gallery_count: "{{n}} immagini",
      invalid_format: "Formato non valido — usa PNG, JPG o WEBP.",
      empty_title: "Moodboard vuoto",
      empty_subtitle: "Aggiungi la prima immagine per iniziare a costruire la visione dell'evento.",
      edit_title: "Modifica immagine",
      image_title: "Titolo",
      category: "Categoria",
      caption: "Nota",
      updated: "Immagine aggiornata",
      share: "Condividi",
      canva_title: "Progetto Canva",
      canva_subtitle: "Salva il link al progetto Canva usato per questo evento. Il collegamento resta privato al tuo workspace.",
      open_canva: "Apri Canva",
      canva_saved: "Link Canva salvato",
      delete_canva: "Rimuovi link",
      delete_canva_confirm: "Rimuovere il link Canva da questo evento?",
      canva_deleted: "Link Canva rimosso",
      preview_unavailable_title: "Anteprima Canva non disponibile",
      preview_unavailable: "Il progetto è ospitato da Canva e questo link non restituisce un'anteprima incorporabile. Aurea Pro funziona correttamente: apri il progetto direttamente su Canva oppure genera un nuovo link pubblico.",
      saving: "Salvataggio…",
      previous: "Immagine precedente",
      next: "Immagine successiva",
    },
  },
};

export default it;
